import Vue from 'vue'
import toast from './Toast.vue'

const ToastTem = Vue.extend(toast);
let instance;
let timer = null;

let toastMessage = (options) => {
    console.log(options)
    if (!instance) {
        instance = new ToastTem()
        instance.vm = instance.$mount()
        document.body.appendChild(instance.vm.$el)
    }
    if (timer) {
        clearTimeout(timer)
        timer = null
        instance.show = false
        instance.message = ''
    }
    let time = 3000
    if (typeof options === 'string') {
        instance.message = options
    } else if (typeof options === 'object') {
        let {
            message,
            time,
            type
        } = options
        instance.message = message
        instance.time = time || 3000
        instance.type = type || "info"
    } else {
        return
    }
    instance.show = true;
    if (instance.time != "infinite") {
        timer = setTimeout(() => {
            instance.show = false
            clearTimeout(timer)
            timer = null
           
        }, instance.time)
    }
}
toastMessage.close = () => {
    try {
        if (timer) {
            clearTimeout(timer)
            timer = null
            instance.show = false
           
        } else {
            instance.show = false
          
        }
    } catch (error) {

    }

}

toastMessage.install = (Vue) => {
    Vue.prototype.$toast = toastMessage
}
export default toastMessage;